import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import LoadingScreen from "../components/LoadingScreen";

export default function ProtectedRouteRole({ roles = ["creator"], children }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  if (loading || profile === undefined) {
    return <LoadingScreen label="กำลังตรวจสอบสิทธิ์…" />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const allowedRoles = Array.isArray(roles) ? roles : [roles];
  const userRole = profile?.role;

  if (!userRole || !allowedRoles.includes(userRole)) {
    return <Navigate to="/account" replace />;
  }

  return children;
}
